import { render, staticRenderFns } from "./MasterJournal.vue?vue&type=template&id=42796a14"
import script from "./MasterJournal.vue?vue&type=script&lang=js"
export * from "./MasterJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports